import Entity from './entity'

export default class PickList extends Entity<number>{
    code : string;
    employeeId : number;
    employeeName : string;
    numOfItem : number;
    numOfObject : number;
    pickwaveId : number;
    type : string;
    maxProductSizeCode: string;
    refTypeCode : string;
    creationTime : Date
    creatorUserId : number;
    creatorUserName : string;
    canAssign: boolean;
    statusName:string;
    typeName:string;
    _disabled: false;
    refId: number;
}